<template>
  <div>
    <mdb-modal size="lg" :show="modal" @close="close">
        <mdb-modal-header>
            <mdb-modal-title><h3>Neuigkeiten</h3></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body
          v-if="messageList.length > 0"
        >
          <div
           v-for="(message, index) in messageList"
           :key="index"
          >
            <div
              v-html="message.Text"
              class="grey lighten-3 my-2 py-2 px-2"
            >
            </div>
          </div>
        </mdb-modal-body>
        <mdb-modal-body
          v-else
        >
          <list-group-item
            class="mt-2"
            :title="'Keine Einträge gefunden'"
          />
        </mdb-modal-body>
        <mdb-modal-footer>
            <mdb-btn color="primary" size="sm" @click.native="close">OK</mdb-btn>
        </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  } from 'mdbvue'
  const ListGroupItem = () => import('@/components/accordion/ListGroupItem')

  export default {
    name: 'NewsModal',

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      ListGroupItem
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        modal: false,
        messageList: []
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    created() {
      this.loadMessage()
    },

    methods: {
      close () {
        this.$emit('close')
      },

      loadMessage () {
        this.$http.get('Nachricht')
          .then(res => {
            this.messageList = res.data.data
          })
      }
    }
  }
</script>
